module.exports = __webpack_public_path__ + "img/live-streaming-map.2904e837.png";